<template>
  <div id="report">
    <header-top :headerText="headerText" showBack></header-top>
    <main class="report-main">
      <el-table
        :data="peopleList"
        :span-method="objectSpanMethod"
        border
      >
        <el-table-column
          label-class-name="tab-tit"
          v-if="tableTitleKey.includes('大区')"
          prop="region"
          label="大区"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <div class="name-worknum">
              <div>
                <span>{{ scope.row.region }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="tableTitleKey.includes('区')"
          prop="area"
          label="区"
          min-width="150"
          align="center"
        />
        <el-table-column
          label-class-name="tab-tit"
          v-if="tableTitleKey.includes('店')"
          prop="store"
          label="店"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.store | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="group"
          label-class-name="tab-tit"
          v-if="tableTitleKey.includes('组')"
          label="组"
          min-width="200"
          align="center"
        />
        <el-table-column
          prop="function"
          label-class-name="tab-tit"
          v-if="tableTitleKey.includes('职能')"
          label="职能"
          width="100"
          align="center"
        />
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('员工人数')" label="员工人数" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.currentNum | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('带训师')" label="带训师" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.teacher | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('一年>')" label="一年>" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.year | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('三年')" label="三年" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.threeYears | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('五年')" label="五年" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fiveYears | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('十年')" label="十年" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.tenYears | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('待入职')" label="待入职" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.employed | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('试用')" label="试用" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.trial | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('转正')" label="转正" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.quit | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('离职')" label="离职" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.quit | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('入职率')" label="入职率" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.entryRate | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('转正率')" label="转正率" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.positiveRate | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('离职率')" label="离职率" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.turnoverRate | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('男')" label="男" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.men | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('女')" label="女" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.women | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('保密')" label="保密" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.secrecy | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('专科')" label="专科" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.specialty | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('本科')" label="本科" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.undergraduate | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('硕士')" label="硕士" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.master | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit"
          v-if="tableTitleKey.includes('博士')" label="博士" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.doctor | nullValue }}</span>
          </template>
        </el-table-column>
        
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img src="../../../../assets/image/loading.png" alt="loading" class="loading-ico" />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading&&!peopleList.length">列表为空</div>
        </template>
      </el-table>
      
    </main>
    <el-dialog
      title="自定义列表字段 "
      :visible.sync="isShowFiltrate"
      width="800px"
      :before-close="closeFiltrate"
      custom-class="filter-dialog"
    >
      <el-transfer
        filterable
        :filter-method="filterMethod"
        :titles="['请选择你想显示的列表字段', '已选择字段']"
        filter-placeholder="请输入字段名称"
        v-model="tableTitleKey"
        :data="tabTitData"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowFiltrate = false">取消</el-button>
        <el-button type="primary" @click="isShowFiltrate = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
// import { peopleList } from "@/http/api/employe";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { tree } from "@/utils/tree";
export default {
  components: {
    headerTop,
    Treeselect
  },
  data() {
    const generateData = _ => {
      const data = [];
      const tabTits = ["大区", "区", "店", "组", "职能", "员工人数", "带训师", "一年>", "三年", "五年","十年",
       "待入职", "试用", "转正", "离职", "入职率", "转正率", "离职率", "男", "女", "保密", "专科", "本科", "硕士", "博士"];
      const pinyin = [
        "daqu",
        "qu",
        "dian",
        "zu",
        "zhineng",
        "yuangongshu",
        "daixunshi",
        "yinian",
        "sannian",
        "wunian",
        "shinian",
        "dairuzhi",
        "shiyong",
        "zhuanzheng",
        "lizhi",
        "ruzhilv",
        "zhuanzhenglv",
        "lizhilv",
        "nan",
        "nv",
        "baomi",
        "zhuanke",
        "benke",
        "shuoshi",
        "boshi",
      ];
      tabTits.forEach((tabTit, index) => {
        data.push({
          label: tabTit,
          key: tabTit,
          pinyin: pinyin[index]
        });
      });
      return data;
    };
    return {
      headerText: "员工入离调转汇总表",
      changeForm: [{}],
      query: {
        limit: 500,
        pageIndex: 1,
        dateRange: "",
        type: ""
      },
      total: 1,
      isLoading: false,
      userTypeFilters: [
        { text: "全部类型", value: "UserAdmin" },
        { text: "网站用户", value: "User" },
        { text: "后台用户", value: "Admin" }
      ],
      normalizer(node) {
        if (node.data && node.data.id) {
          return {
            id: node.data.name,
            label: node.data.name,
            children: node.children
          };
        }
      },
      config: ["disabled-checked"],
      orgList: [],
      org: null,
      peopleList: [
        {
          region: "宏业大区",
          area: "宏业1区",
          store: "宜家店",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,        
        },
        {
          region: "宏业大区",
          area: "宏业1区",
          store: "宜家店3",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,            
        },
        {
          region: "宏业大区",
          area: "宏业2区",
          store: "宜家店1",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher: 30,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,               
        },
        {
          region: "宏业大区",
          area: "宏业2区",
          store: "宜家店1",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,               
        },
        {
          region: "宏业大区",
          area: "宏业2区",
          store: "宜家店2",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,               
        },
        {
          region: "宏业大区",
          area: "宏业2区",
          store: "宜家店2",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,               
        },


        {
          region: "宏准大区",
          area: "宏业1区",
          store: "宜家店",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,               
        },
        {
          region: "宏准大区",
          area: "宏业1区",
          store: "宜家店3",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,               
        },
        {
          region: "宏准大区",
          area: "宏业2区",
          store: "宜家店1",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,               
        },
        {
          region: "宏准大区",
          area: "宏业2区",
          store: "宜家店1",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,               
        },
        {
          region: "宏准大区",
          area: "宏业2区",
          store: "宜家店2",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,               
        },
        {
          region: "宏准大区",
          area: "宏业2区",
          store: "宜家店2",
          group: "弘业宜家店C组",
          function: "无",
          currentNum: 20,
          teacher:10,
          year:20,
          threeYears:10,
          fiveYears:10,
          tenYears:10,
          employed:2,
          trial:2,
          quit:2,
          entryRate:2,
          positiveRate:2,
          turnoverRate:2,
          men:2,
          women:2,
          secrecy:2,
          specialty:2,
          undergraduate: 20,    
          master:2,
          doctor: 20,            
        },
      ],
      spanData: [],
      isShowFiltrate:false,
      tabTitData: generateData(), //字段穿梭框数据
      tableTitleKey: ["大区", "区", "店", "组", "职能", "员工人数", "带训师", "一年>", "三年", "五年","十年", "待入职", "试用", "转正", "离职", "入职率", "转正率", "离职率", "男", "女", "保密", "专科", "本科", "硕士", "博士"], //穿梭框已选择字段名
      pos: 0,
      needMergeArr: ["region", "area", "store"]
    };
  },
  mounted() {
    this.getpeopleList();
    
    this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.peopleList);
  },
  methods: {
    //关闭穿梭框
    closeFiltrate() {
      this.isShowFiltrate = false;
      //   //console.log(this.tableTitleKey);
    },
    //筛选穿梭框
    filterMethod(query, item) {
      return item.pinyin.indexOf(query) > -1 || item.label.indexOf(query) > -1;
    },
    // 合并行
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (column.property === "region")
        return this.mergeAction("region", rowIndex, column);
      if (column.property === "area")
        return this.mergeAction("area", rowIndex, column);
      if (column.property === "store")
        return this.mergeAction("store", rowIndex, column);
    },
    mergeAction(val, rowIndex, colData) {
      let _row = this.rowMergeArrs[val].rowArr[rowIndex];
      let _col = _row > 0 ? 1 : 0;
      return [_row, _col];
    },
    rowMergeHandle(arr, data) {
      if (!Array.isArray(arr) && !arr.length) return false;
      if (!Array.isArray(data) && !data.length) return false;
      let needMerge = {};
      arr.forEach(i => {
        needMerge[i] = {
          rowArr: [],
          rowMergeNum: 0
        };
        data.forEach((item, index) => {
          if (index === 0) {
            needMerge[i].rowArr.push(1);
            needMerge[i].rowMergeNum = 0;
          } else {
            if (item[i] === data[index - 1][i]) {
              needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
              needMerge[i].rowArr.push(0);
            } else {
              needMerge[i].rowArr.push(1);
              needMerge[i].rowMergeNum = index;
            }
          }
        });
      });
      return needMerge;
    },


    refresh() {
      //console.log("刷新");
    },
    filtrate() {
      //console.log("筛选");
    },
    setFilterDays(num) {
      let start = new Date(
        new Date(new Date().setHours(0, 0, 0, 0)).getTime() -
          24 * 60 * 60 * 1000 * num
      ).toLocaleString("chinese", { hour12: false });
      let end = new Date().toLocaleString("chinese", { hour12: false });
      this.query.dateRange = [start, end];
    },
 
    changeSort(val) {
      //console.log(val);
      this.query.order = val.prop;
      val.order == "descending"
        ? (this.query.sort = "desc")
        : val.order == "ascending"
        ? (this.query.sort = "asc")
        : "";
      //console.log(val.order, this.query.sort);
      this.getpeopleList();
    },
    getpeopleList() {
      //console.log("获取的时间筛选", this.time);
      if (this.time != "" && this.time != null) {
        this.query.start = this.time[0];
        this.query.end = this.time[1];
      } else {
        this.query.start = "";
        this.query.end = "";
      }
    },
    handleCurrentChange(val) {
      //console.log("跳转的指定页", val);
      this.query.pageIndex = val;
    },
    handleSizeChange(val) {
      //console.log("更改的页面数量", val);
      this.query.limit = val;
    }
  }
};
</script>
<style scoped lang='scss'>
.report-main {
  padding: 20px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);

  .el-table {
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    font-size: 12px;
    background: #fff;
    ::v-deep .el-table__body-wrapper {
      min-height: calc(100vh - 275px);
    }
    .table-operation {
      display: flex;
      .el-button + .el-button {
        margin-left: 10px;
      }
    }
  }
}
</style>